<template>
  <div id="app" @click="unlockAudio" class="app-container">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  errorCaptured(err, instance, info) {
    // Handle Vue component errors
    console.error('Vue Error Captured:', err, info);
    
    // Suppress known external script errors
    if (err.message && err.message.includes('share-modal')) {
      console.warn('External share-modal error suppressed in Vue');
      return false; // Prevent the error from propagating
    }
    
    return true; // Let other errors propagate
  },
  setup() {
    const unlockAudio = () => {
      // For browsers that require user interaction before playing audio
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        oscillator.connect(audioContext.createGain());
        oscillator.disconnect();
        audioContext.resume();
      } catch (e) {
        console.error('Audio context unlock failed', e);
      }
    }
    
    return {
      unlockAudio
    }
  }
}
</script>

<style>
.text-primary {
  color: #333333 !important;
}

/* Also override the btn-primary for consistency */
.btn-primary {
  background-color: #333333;
  border-color: #333333;
}

.btn-primary:hover {
  background-color: #222222;
  border-color: #222222;
}

/* Override for link colors */
a.text-primary {
  color: #333333 !important;
}

a.text-primary:hover {
  color: #222222 !important;
}
</style>
